import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'

const state = {
  isLoggedIn: false,
  userTypeList: [
    { user_type_id: 1, value: 1, user_type_name: 'Dealer', user_type_name_bn: 'ডিলার', text: 'Dealer' },
    { user_type_id: 2, value: 2, user_type_name: 'Retailer', user_type_name_bn: 'খুচরা বিক্রেতা', text: 'Retailer' },
    { user_type_id: 3, value: 3, user_type_name: 'Grant', user_type_name_bn: 'গ্রান্ট', text: 'Grant' }
  ],
  authUser: null,
  accessToken: null,
  questions: [],
  authUserRoles: [],
  activeRoleId: 0,
  authorizedComponents: [],
  activeComponentId: 0,
  activeMenus: [],
  authorizedURIs: ['/home'],
  unauthorizedAccessCounter: 0,
  orgList: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
